import "@/App.css";
import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Treatments } from "@/components/Treatments";
import { Packages } from "@/components/Packages";
import { FlowerCards } from "@/components/FlowerCards";
import { Experience } from "@/components/Experience";
import { Appointment } from "@/components/Appointment";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";
import { LegalModal } from "@/components/Legal";
import { CertificatesModal } from "@/components/Certificates";

function App() {
    const [certsOpen, setCertsOpen] = useState(false);
    const [legalDoc, setLegalDoc] = useState(null);
    const openCerts = () => setCertsOpen(true);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);

        const onClick = (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            const target = document.querySelector(link.getAttribute("href"));
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -90 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    useEffect(() => {
        const track = (e) => {
            if (typeof window.gtag !== "function") return;
            const link = e.target.closest("a");
            if (!link) return;
            const href = link.href || "";
            if (href.includes("store.dorie.io")) {
                window.gtag("event", "click_booking", { link_text: link.textContent.trim().slice(0, 40) });
            } else if (href.includes("wa.me")) {
                window.gtag("event", "click_whatsapp", { link_text: link.textContent.trim().slice(0, 40) });
            } else if (href.startsWith("tel:")) {
                window.gtag("event", "click_phone", {});
            }
        };
        document.addEventListener("click", track);
        return () => document.removeEventListener("click", track);
    }, []);

    return (
        <div className="App font-body bg-miam-cream text-miam-dark" dir="rtl">
            <div
                data-testid="women-only-banner"
                className="bg-miam-rose px-5 py-2.5 text-center"
            >
                <p className="text-sm font-bold text-white">
                    العيادة مخصصة للنساء فقط
                </p>
            </div>
            <Header onOpenCertificates={openCerts} />
            <main>
                <Hero />
                <About onOpenCertificates={openCerts} />
                <Treatments />
                <Packages />
                <Experience />
                <Appointment />
                <Contact />
                <FlowerCards />
            </main>
            <Footer onOpenCertificates={openCerts} onOpenLegal={setLegalDoc} />
            <FloatingButtons />
            <CertificatesModal open={certsOpen} onClose={() => setCertsOpen(false)} />
            <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} />
        </div>
    );
}

export default App;
